export const TRIGGER_MFE_CREDIT_CARD_SUBMIT = 'TRIGGER_MFE_CREDIT_CARD_SUBMIT';
